import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ttsConcat'
})
export class TtsConcat implements PipeTransform {

  constructor() {}

  transform(separator: string, ...values: string[]): string {
    const translations = values.filter((val)=>!!val);
    return translations.join(separator);
  }
}